// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__1VCTY","label":"Radio_label__3snu7","checkMark":"Radio_checkMark__20OsS","disabled":"Radio_disabled__uPFkx"};